import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { resetPassword } from "../../api/mliAppApi";
import { useLocation } from "react-router-dom";
import { useApplicationContext } from "../ContextProviders/ApplicationContext";
export type ResetPassword = {
  password: string;
  confirm: string;
  userId?: string | null;
  code?: string | null;
};

const ResetPasswordPage: React.FC = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const code = queryParams.get("CODE") ?? "";
  const userId = queryParams.get("USER_ID");
  const {showSnackbar} = useApplicationContext()

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    register,
  } = useForm<ResetPassword>({
    defaultValues: {
      password: "",
      confirm: "",
      userId,
      code,
    },
  });

  const onSubmit = async (data: ResetPassword) => {
    try {
      await resetPassword(data);
        reset({});
      showSnackbar("Password changed, you can now login with your new password", "success")
    } catch (e) {
      showSnackbar("Unexpected error", "error")
    }
  };

  return (
    <Box sx={{ backgroundColor: "#161616" }} height={"100vh"}>
      <img
        src="https://precurecdnstorage.blob.core.windows.net/images/Precure_logo_RGB_Hvide_Bogstaver.svg"
        width={250}
        style={{ padding: 20 }}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item flexGrow={1} />
          <Grid item xs={10} md={4}>
            <Grid container direction={"column"} spacing={2}>
              <Grid item xs>
                <Typography
                  sx={{ textAlign: "center", marginBottom: 4 }}
                  color={"white"}
                  variant="h4"
                >
                  Password recovery
                </Typography>
              </Grid>
              <Grid item xs>
                <Controller
                  name="password"
                  rules={{
                    required: true,
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    validate: {
                      hasUpperCase: (value) =>
                        /[A-Z]/.test(value) ||
                        "Must contain an uppercase letter",
                      hasLowerCase: (value) =>
                        /[a-z]/.test(value) ||
                        "Must contain a lowercase letter",
                      hasNumber: (value) =>
                        /[0-9]/.test(value) || "Must contain a number",
                      hasSpecialChar: (value) =>
                        /[^A-Za-z0-9]/.test(value) ||
                        "Must contain a special character",
                    },
                  }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      required
                      type="password"
                      variant="outlined"
                      fullWidth
                      error={!!error}
                      helperText={error ? error.message : null}
                      autoComplete="new-password"
                      label="New Password"
                      {...field}
                      sx={{
                        input: { color: "white" },

                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#5BBFAC",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#5BBFAC",
                          },
                        },
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs>
                <Controller
                  name="confirm"
                  control={control}
                  rules={{
                    required: { value: true, message: "Required" },

                    validate: (value) =>
                      value === getValues("password") ||
                      "Passwords do not match",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      required
                      fullWidth
                      error={!!error}
                      helperText={error?.message}
                      autoComplete="new-password"
                      label="Confirm Password"
                      type="password"
                      {...field}
                      sx={{
                        input: { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "white",
                          },
                          "&:hover fieldset": {
                            borderColor: "#5BBFAC",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#5BBFAC",
                          },
                        },
                      }}
                    />
                  )}
                />
                <input {...register("code")} type="hidden" />
                <input {...register("userId")} type="hidden" />
              </Grid>
              <Grid item xs>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ float: "right" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item flexGrow={1} />
        </Grid>
      </form>
    </Box>
  );
};

export default ResetPasswordPage;
